export default __webpack_public_path__ + "static/media/480_business01-es-web.7a12ec64.png";